export interface LegalSection {
  title: string;
  paragraphs?: readonly string[];
  bullets?: readonly string[];
}

export interface LegalPage {
  slug: string;
  eyebrow: string;
  title: string;
  description: string;
  updated?: string;
  sections: readonly LegalSection[];
  email?: string;
  address?: readonly string[];
}
import { LEGAL_CORE_PAGES } from "./legal-pages/core-pages";
import { LEGAL_SUPPORT_PAGES } from "./legal-pages/support-pages";

export const LEGAL_PAGES: Readonly<Record<string, LegalPage>> = {
  ...LEGAL_CORE_PAGES,
  ...LEGAL_SUPPORT_PAGES,
};
